import { Drawer, Empty } from "antd";
import React from "react";

const ViewReport: React.FC<any> = (props) => {
  const { visible, close, reportData } = props;

  return (
    <Drawer
      open={visible}
      destroyOnClose
      width={900}
      onClose={close}
      footer={false}
      className="addModal"
      title={`View Report`}
    >
      {reportData ? (
        <div style={{ whiteSpace: "pre-wrap" }}>
          {JSON.stringify(reportData, null, 5)}
        </div>
      ) : (
        <Empty />
      )}
    </Drawer>
  );
};

export default ViewReport;
